import { IconMastHead } from '@assets/icons'
import { Container, Flex } from '@chakra-ui/react'
import { Text } from '@components/Common'

export default function Masthead() {
  return (
    <Flex bg="#F0F0F0" py="8px" h="41px">
      <Container display="flex" alignItems="center">
        <IconMastHead />
        <Text as="smallText" ml="5px">
          A Singapore Government Agency Website
        </Text>
      </Container>
    </Flex>
  )
}
